import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import { ExportToExcel } from '../../../../../../components/ExportToExcel';

export default function Report(props) {
  const { openDialog, setOpenDialog, sales, deliver } = props;
  const [data, setData] = React.useState([]);
  function MobileColumnFormatter(cellContent, row) {
    if (row.mobile2 && row.mobile2.length > 0)
      return <span>{`${cellContent}, ${row.mobile2}`}</span>;
    else return <span>{cellContent}</span>;
  }
  function AddressColumnFormatter(cellContent, row) {
    if (!row.location) return <span>{`Төлсөн: ${cellContent}`}</span>;
    if (row.location !== 'Ulaanbaatar')
      return <span>{`Төлсөн: ${row.district} аймаг, ${cellContent}`}</span>;
    else return <span>{`Төлсөн: ${row.district}, ${cellContent}`}</span>;
  }
  const columns = [
    {
      dataField: 'нэр',
      text: 'Нэр',
      sort: false,
      style: {
        width: '65px',
      },
    },
    {
      dataField: 'утас',
      text: 'Утас',
      sort: false,
      style: {
        width: '65px',
      },
    },
    {
      dataField: 'хаяг',
      text: 'Хаяг',
      sort: false,
      style: {
        width: '200px',
      },
    },
  ];

  React.useEffect(() => {
    console.log('Report', sales);
    let filteredData = [];
    for (var i = 0; i < sales.length; i++) {
      let sale = sales[i];
      if (sale.boxed) {
        filteredData.push({
          нэр: sale.fbName,
          утас: sale.mobile2 ? sale.mobile + ', ' + sale.mobile2 : sale.mobile,
          хаяг: `Төлсөн: ${
            sale.district ? sale.district + ', ' + sale.address : sale.address
          }`,
        });
      }
    }
    setData(filteredData);
  }, [sales]);

  return (
    <Modal
      size='lg'
      show={openDialog}
      onHide={() => setOpenDialog(false)}
      backdrop='static'
      keyboard={false}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      <Modal.Header>
        <Modal.Title id='confirm-dialog'>
          Хүргэлт: {deliver.deliverCode}
          <br />
          Бараа: {deliver.boxedCount}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <div>
            <BootstrapTable
              wrapperClasses='table-responsive'
              classes='table table-head-custom table-vertical-center overflow-hidden'
              bootstrap4
              bordered={true}
              local
              keyField='productCode'
              data={data === null ? [] : data}
              columns={columns}
            >
              <PleaseWaitMessage entities={data} />
              <NoRecordsFoundMessage entities={data} />
            </BootstrapTable>
          </div>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <button
          type='button'
          className='btn btn-default ml-2'
          onClick={() => {
            setOpenDialog(false);
          }}
        >
          Болих
        </button>
        {data.length > 0 && (
          <ExportToExcel
            apiData={data}
            fileName={deliver.deliverCode}
            buttonText='Экспортлох'
          ></ExportToExcel>
        )}
      </Modal.Footer>
    </Modal>
  );
}
